import type { FunctionComponent } from "react";

import { FeedViewArticles } from "scmp-app/components/my-news/feed-view-articles";
import { TopicFiltering } from "scmp-app/components/my-news/topic-filtering";

import { MynewsFeedViewProvider } from "./context";
import { Container, Title } from "./styles";

export const FeedView: FunctionComponent = () => (
  <MynewsFeedViewProvider>
    <Container>
      <Title>More stories you might like</Title>
      <TopicFiltering />
      <FeedViewArticles />
    </Container>
  </MynewsFeedViewProvider>
);

FeedView.displayName = "FeedView";
